/* eslint-disable @typescript-eslint/naming-convention */
import httpFactory from '@adjust/dashboard-core/api/instance/http-factory';

const TrackerService = httpFactory({ baseURL: configurationURL.dashboard.baseUrl + '/api/apps' });

export const getTrackerList = ({ appToken, includeArchived, includeCTV, ...params }) =>
  TrackerService.get(`/${appToken}/trackers`, {
    params: {
      ...params,
      include_archived: includeArchived,
      include_ctv: includeCTV,
    },
  }).then(response => response?.data?.trackers || []);

export const getTrackerListWithAccessDetails = ({ appToken, access, ...params }) =>
  getTrackerList({ appToken, includeArchived: true, includeCTV: true, ...params }).then(response => {
    const trackerList = response;

    if (!access?.trackers) {
      return trackerList;
    }

    return trackerList.map(tracker => {
      const accessDetail = access.trackers.find(accessDetail => String(accessDetail.token) === String(tracker.token));

      if (accessDetail) {
        tracker.access = accessDetail;
      }

      return tracker;
    });
  });
